/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import * as R from 'ramda';
import {
  selectDeleteSession,
  selectSearchSessions,
  selectSessionsList
} from '@nebula/dorado-redux-storage';

import { createSelector } from 'reselect';
import { matchProp } from '../common/util/search.util';
import { sessionListSearch, sessionListTab, isSearching } from './data/prefabs';
import { selectRecentSessions } from '../common/selectors';

const filterSessionsList = searchValue => R.filter(matchProp(searchValue, 'name'));

const selectTabbedSessionsList = createSelector(
  selectSessionsList,
  sessionListTab.value,
  selectRecentSessions,
  (sessions, tabValue, recentSessions) => (tabValue === 0 ? sessions
    : R.filter(({ uuid }) => recentSessions.indexOf(uuid) > -1, sessions)
  )
);

export const selectSessionsLoading = createSelector(
  isSearching.isOn,
  selectDeleteSession.loading,
  selectSessionsList.loading,
  (searching, deleting, loading) => (searching || deleting || loading)
);

const selectSearchResults = (state) => {
  const search = sessionListSearch.value(state);
  return selectSearchSessions(search, state);
};

const selectSearchError = (state) => {
  const search = sessionListSearch.value(state);
  return selectSearchSessions(search).error(state);
};

export const selectSearchFilteredSessions = createSelector(
  selectTabbedSessionsList,
  sessionListSearch.value,
  selectSearchResults,
  sessionListTab.value,
  selectSearchError,
  (sessions, searchValue, searchResults, tabValue, searchError) => (
    searchValue === '' ? sessions
      : (tabValue !== 0 || searchError)
        ? filterSessionsList(searchValue)(sessions) : searchResults
  )
);
